(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["topshelf-variant-upc"] && !Shopify.designMode) return;
  try {
    class TopShelfVariantUpc extends HTMLElement {
    #abortController = new AbortController();

    connectedCallback() {
      this.closest('.shopify-section')?.addEventListener('shopify:product:select', this.#handleProductSelect, {
        signal: this.#abortController.signal,
      });
    }

    disconnectedCallback() {
      this.#abortController.abort();
    }

    #handleProductSelect = (event) => {
      const promise = event.promise;
      if (!promise || typeof promise.then !== 'function') return;

      promise
        .then(({ detail }) => {
          if (detail?.productId !== this.dataset.productId) return;

          const updatedComponent = detail.html?.querySelector(
            `topshelf-variant-upc[data-product-id="${this.dataset.productId}"]`
          );
          const currentLine = this.querySelector('.product-upc');
          const updatedLine = updatedComponent?.querySelector('.product-upc');

          if (!currentLine || !updatedLine) return;

          currentLine.textContent = updatedLine.textContent;
          currentLine.hidden = updatedLine.hidden;
        })
        .catch(() => {});
    };
  }

  if (!customElements.get('topshelf-variant-upc')) {
    customElements.define('topshelf-variant-upc', TopShelfVariantUpc);
  }
  } catch(e) { console.error(e); }
})();

})();
